(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mn-brand-presence"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mn-wall-home]').forEach((root) => {
      if (root.dataset.mnWallReady === 'scroll-v2') return;
      root.dataset.mnWallReady = 'scroll-v2';
      const before = root.querySelector('[data-mn-wall-before]');
      const after = root.querySelector('[data-mn-wall-after]');
      const media = root.querySelector('[data-mn-wall-media]');
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let active = true;
      let frame = 0;
      let lastProgress = -1;
      let scene = '';
      const clamp = (value) => Math.max(0, Math.min(1, value));
      const smooth = (value) => value * value * (3 - 2 * value);
      const px = (value) => value.toFixed(3) + 'px';
      const render = () => {
        frame = 0;
        if (!root.isConnected) return;
        const rect = root.getBoundingClientRect();
        const viewport = document.documentElement.clientHeight || window.innerHeight;
        const progress = preference.matches ? 1 : clamp((viewport * .8 - rect.top) / (viewport * .6 + rect.height * .35));
        if (progress === lastProgress) return;
        lastProgress = progress;
        const reveal = preference.matches ? 1 : smooth(clamp((progress - .32) / .34));
        const beforeOpacity = preference.matches ? 0 : 1 - smooth(clamp((progress - .32) / .16));
        const afterOpacity = preference.matches ? 1 : smooth(clamp((progress - .50) / .16));
        const mobile = root.clientWidth < 740;
        const depth = preference.matches ? 0 : mobile ? 12 : 28;
        root.style.setProperty('--mn-wall-reveal', reveal.toFixed(5));
        root.style.setProperty('--mn-wall-before-opacity', beforeOpacity.toFixed(5));
        root.style.setProperty('--mn-wall-after-opacity', afterOpacity.toFixed(5));
        root.style.setProperty('--mn-wall-blend', (reveal * 100).toFixed(3) + '%');
        root.style.setProperty('--mn-wall-copy-x', px(-progress * depth * .45));
        root.style.setProperty('--mn-wall-copy-y', px((.5 - progress) * depth * .55));
        root.style.setProperty('--mn-wall-before-x', px(progress * depth));
        root.style.setProperty('--mn-wall-before-y', px(-progress * depth * .8));
        root.style.setProperty('--mn-wall-after-x', px((1 - progress) * depth * 1.4));
        root.style.setProperty('--mn-wall-after-y', px((1 - progress) * depth * .8));
        root.style.setProperty('--mn-wall-before-title-y', px(-(1 - beforeOpacity) * 32));
        root.style.setProperty('--mn-wall-after-title-y', px((1 - afterOpacity) * 32));
        root.style.setProperty('--mn-wall-background-y', px((progress - .5) * depth * .4));
        root.dataset.mnWallProgress = progress.toFixed(5);
        root.dataset.mnWallReveal = reveal.toFixed(5);
        const nextScene = reveal >= .5 ? 'glowing' : 'bored';
        if (scene !== nextScene) {
          scene = nextScene;
          const glowing = scene === 'glowing';
          root.dataset.mnWallState = scene;
          root.classList.toggle('is-glowing', glowing);
          before.setAttribute('aria-hidden', String(glowing));
          after.setAttribute('aria-hidden', String(!glowing));
          media.setAttribute('aria-label', glowing ? media.dataset.afterLabel : media.dataset.beforeLabel);
        }
      };
      const schedule = () => {
        if (active && !frame) frame = requestAnimationFrame(render);
      };
      const refresh = () => {
        lastProgress = -1;
        if (!frame) frame = requestAnimationFrame(render);
      };
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            active = entry.isIntersecting;
            refresh();
          }
        }, { threshold: 0 });
        observer.observe(root);
      }
      const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(refresh) : null;
      if (resizeObserver) resizeObserver.observe(root);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', refresh, { passive: true });
      window.addEventListener('pageshow', refresh);
      preference.addEventListener('change', refresh);
      render();
      const unload = (event) => {
        if (!event.target.contains(root)) return;
        if (observer) observer.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        if (frame) cancelAnimationFrame(frame);
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', refresh);
        window.removeEventListener('pageshow', refresh);
        preference.removeEventListener('change', refresh);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mn-unboxing-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mn-unboxing-player')) {
  customElements.define('mn-unboxing-player', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || this.dataset.ready) return;
      this.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.preload = 'none';
        video.tabIndex = 0;
        video.setAttribute('aria-label', this.dataset.videoLabel);
        video.src = this.dataset.videoUrl;
        video.addEventListener('error', () => {
          if (this.querySelector('.mn-unboxing__error')) return;
          const link = document.createElement('a');
          link.className = 'mn-unboxing__error';
          link.href = this.dataset.videoUrl;
          link.textContent = this.dataset.errorLabel;
          this.append(link);
        });
        this.replaceChildren(video);
        video.focus({preventScroll:true});
        video.play().catch(() => {});
        this.video = video;
        this.observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) video.pause();
        });
        this.observer.observe(this);
        this.onVisibility = () => { if (document.hidden) video.pause(); };
        document.addEventListener('visibilitychange', this.onVisibility);
      }, {once:true});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-tags"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    window.__sfWindowLoaded = true;
  });

  var fader = document.querySelector('.m-page-transition');
  function __fadeInPage() {
    if (!window.AnimationEvent || !fader) return;

    let ignore_beforeunload = false;

    document.querySelectorAll('a[href^=mailto], a[href^=tel]').forEach((link) => {
      link.addEventListener('click', () => {
        ignore_beforeunload = true;
      });
    });
    window.addEventListener('beforeunload', () => {
      if (!ignore_beforeunload) fader.classList.add('fade-in');
    });
    window.addEventListener('DOMContentLoaded', () => {
      document.documentElement.classList.remove('m:overflow-hidden');
      document.body.classList.remove('m:overflow-hidden');
      setTimeout(() => {
        fader.classList.add('fade-out');
      }, 300);

      document.dispatchEvent(new CustomEvent('page:loaded'));
    });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        fader.classList.remove('fade-in');
      }
    });
  }
  __fadeInPage();
  function addIntersectionObserver(classSelector, newClass = '') {
    let lazyImages = [].slice.call(document.getElementsByClassName(classSelector));
    if ('IntersectionObserver' in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.classList.remove(classSelector);
            newClass && lazyImage.classList.remove(newClass);
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }
  }
  function handleBackgroundImageLazyload() {
    return addIntersectionObserver('m-bg-lazy');
  }

  handleBackgroundImageLazyload();
  document.addEventListener('shopify:section:load', () => {
    handleBackgroundImageLazyload();
  });
  function __scrollToTop(element, callback) {
    if (!element) element = document.querySelector('#scroll-to-top-target');
    element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    if (callback) callback();
  }

  function __initScrollTop() {
    const scrollTopButton = document.querySelector('#scroll-to-top-button');
    if (scrollTopButton) {
      scrollTopButton.addEventListener('click', () => __scrollToTop());
      window.addEventListener('scroll', function () {
        const method = window.scrollY > 100 ? 'add' : 'remove';
        scrollTopButton.classList[method]('is-show');
      });
    }
  }
  function __initTermsCheckbox() {
    addEventDelegate({
      selector: '.m-terms-conditons [name="agree_terms"]',
      event: 'change',
      handler: (e, target) => {
        let button = target.closest('.m-terms-conditons').nextElementSibling;
        while (button) {
          if (button.hasAttribute('data-terms-action')) {
            break;
          }

          button = button.nextElementSibling;
        }
        if (button && button.hasAttributes('data-terms-action')) {
          if (target.checked) {
            button.removeAttribute('disabled');
          } else {
            button.setAttribute('disabled', true);
          }
        }
      },
    });
  }

  window.addEventListener('load', () => {
    __initScrollTop();
    __initTermsCheckbox();
  });

  Object.assign(window, { __scrollToTop, __initScrollTop, addIntersectionObserver, handleBackgroundImageLazyload, __fadeInPage, __initTermsCheckbox });
  window.fader = fader;
  } catch(e) { console.error(e); }
})();

})();
